module.exports = __webpack_public_path__ + "img/icon-empty-coaching-course.9144ee7a.svg";